<script setup lang="ts">

import { TagLine } from "@components/TagLine";

</script>

<template>

    <div class="max-w-5xl mx-auto text-center tracking-wider pt-8 pb-16 md:pt-16 px-4">
        <div class="text-3xl md:text-5xl font-semibold">
            Everyday <span class="text-primary-600 uppercase font-bold">WEAR &amp; TEAR</span> protection
        </div>
        <div class="text-3xl md:text-5xl font-semibold mt-4">
            that looks after the parts of your car 
        </div>
        <div class="text-3xl md:text-5xl font-semibold mt-4">
            that your warranty doesn't reach
        </div>
        <TagLine />
    </div>

</template>